export default defineAppConfig({
  una: {
    primary: 'indigo',
    gray: 'slate',
  },
})
